import { render, staticRenderFns } from "./newsContent.vue?vue&type=template&id=4658d5bc&"
import script from "./newsContent.vue?vue&type=script&lang=js&"
export * from "./newsContent.vue?vue&type=script&lang=js&"
import style0 from "./newsContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports